export default __webpack_public_path__ + "static/bauer-media-caab6a9f519634d35df69d987c402001.png";